(ns frontend.view.grid.kyc-grid.columns
  (:require
   [frontend.state.current-session :as session]))

;;default set of selected columns
(def ordered-default-columns
  [:kyc-profile/name
   :kyc-profile/status
   :kyc-profile/risk-category
   :kyc-profile/next-deadline
   :kyc-profile/latest-process-status
   :kyc-profile/their-kyc-contact
   :kyc-profile/our-kyc-contact])

(def default-columns
  (set ordered-default-columns))

(defn get-ordered-default-columns
  []
  (vec
   (concat [:kyc-profile/name
            :kyc-profile/status]
           (when (session/screening?)
             [:kyc-profile/screening-status])
           [:kyc-profile/risk-category
            :kyc-profile/next-deadline
            :kyc-profile/latest-process-status
            :kyc-profile/their-kyc-contact
            :kyc-profile/our-kyc-contact])))

(defn get-default-columns
  []
  (set
   (concat [:kyc-profile/name
            :kyc-profile/status]
           (when (session/screening?)
             [:kyc-profile/screening-status])
           [:kyc-profile/risk-category
            :kyc-profile/next-deadline
            :kyc-profile/latest-process-status
            :kyc-profile/their-kyc-contact
            :kyc-profile/our-kyc-contact])))

;;always selected:
(def mandatory?
  #{:kyc-profile/name})
